module.exports = __webpack_public_path__ + "img/studyOne.3dd39868.png";